import { DefaultState, DropdownItem } from 'store/types';
import { Filters } from 'store/types';

export const GET_GUESTS_FOR_FILTER_REQUEST = 'GET_GUESTS_FOR_FILTER_REQUEST';
export const GET_GUESTS_FOR_FILTER_SUCCESS = 'GET_GUESTS_FOR_FILTER_SUCCESS';
export const GET_GUESTS_FOR_FILTER_FAILURE = 'GET_GUESTS_FOR_FILTER_FAILURE';

export interface GetGuestsForFilterParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  }
};

export interface GetGuestsForFilterData {
  rows: DropdownItem[];
  totalCount: number;
}

export type GetGuestsForFilterState = DefaultState & {
  contents?: GetGuestsForFilterData;
};

interface ReadGetGuestsForFilterRequest {
  type: typeof GET_GUESTS_FOR_FILTER_REQUEST;
};

interface ReadGetGuestsForFilterSuccess {
  type: typeof GET_GUESTS_FOR_FILTER_SUCCESS,
  contents: GetGuestsForFilterData;
}

interface ReadGetGuestsForFilterFailure {
  type: typeof GET_GUESTS_FOR_FILTER_FAILURE;
}

export type GetGuestsForFilterActionTypes = ReadGetGuestsForFilterRequest | ReadGetGuestsForFilterSuccess | ReadGetGuestsForFilterFailure;